var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 5000",
    style: {
      enableBackground: "new 0 0 5000 5000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4284.7383,
    y1: 715.2617,
    x2: 737.4381,
    y2: 4262.562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6B038"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06021906,
    style: {
      stopColor: "#D6AB39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1299,
    style: {
      stopColor: "#D59D3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2043,
    style: {
      stopColor: "#D3863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    style: {
      stopColor: "#D16540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3614,
    style: {
      stopColor: "#CE3C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3973,
    style: {
      stopColor: "#CC2747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4526,
    style: {
      stopColor: "#CA284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5075,
    style: {
      stopColor: "#C52B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    style: {
      stopColor: "#BB306B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6169,
    style: {
      stopColor: "#AF3787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6568,
    style: {
      stopColor: "#A33EA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    style: {
      stopColor: "#9C3EA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7964,
    style: {
      stopColor: "#893E9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    style: {
      stopColor: "#693F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F3F9E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2500,5000L2500,5000C1119.3,5000,0,3880.7,0,2500v0C0,1119.3,1119.3,0,2500,0h0 c1380.7,0,2500,1119.3,2500,2500v0C5000,3880.7,3880.7,5000,2500,5000z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3081.2,1125H1918.7c-438.4,0-793.7,355.4-793.7,793.7v1162.5c0,438.4,355.4,793.8,793.7,793.8h1162.5 c438.4,0,793.7-355.3,793.7-793.8V1918.7C3875,1480.4,3519.6,1125,3081.2,1125 M3621.7,3101.7c0,291-235.9,526.9-526.9,526.9 H1905.1c-291,0-526.9-235.9-526.9-526.9V1912c0-291,235.9-526.9,526.9-526.9h1189.7c291,0,526.9,235.8,526.9,526.9V3101.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2500,1793.3c-394.1,0-713.5,319.4-713.5,713.5c0,394.1,319.5,713.6,713.5,713.6 c394.1,0,713.6-319.5,713.6-713.6C3213.5,2112.7,2894.1,1793.3,2500,1793.3 M2500,2969.4c-255.5,0-462.5-207.1-462.5-462.5 c0-255.5,207.1-462.5,462.5-462.5c255.5,0,462.5,207,462.5,462.5C2962.5,2762.3,2755.5,2969.4,2500,2969.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3237.3,1599.9c-91.8,0-166.2,74.4-166.2,166.2c0,91.8,74.4,166.2,166.2,166.2c91.8,0,166.2-74.4,166.2-166.2 C3403.6,1674.4,3329.1,1599.9,3237.3,1599.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.4655f198f3106d7f361444812f208857.svg";
export { ForwardRef as ReactComponent };